define(['jquery', 'ajax_helper', 'forms'], function ($, AjaxHelper, Forms) {

	var ClaimsWidget = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.$widget = self.$ervBody.find('[data-css="claims-widget"]');
		self.ajaxHelper = new AjaxHelper();
		self.forms = new Forms();
		self.$target = $(self.$widget.data('target'));

		self.initEventhandlers = function () {
			self.$widget.on('change', '[data-js="toggler-filesorreport"] input[type="radio"]', function () {
				var $radio = $(this);

				self.$target.html('');

				if ($radio.prop('checked')) {
					self.$widget.attr('action', $radio.val());

					var $languagePicker = self.$widget.find('[data-js="language"]');

					if ($radio.attr('id') === 'GetReportStatus') {
						$languagePicker.removeClass('hide');
						self.forms.disableFormElementsInContainer($languagePicker, false);
					} else {
						$languagePicker.addClass('hide');
						self.forms.disableFormElementsInContainer($languagePicker, true);
					}
				}
			});

			self.$widget.on('submit', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if (!self.$widget.valid()) {
					return;
				}

				self.$target.html('');

				self.ajaxHelper.submitForm(self.$widget, function (data) {
					if (self.$widget.find('[data-js="toggler-filesorreport"] input[type="radio"]:checked').attr('id') === 'GetReportStatus') {
						self.$target.html('Report opened in new window, if not, disable your adblocker and try again.');
						if (data.message != '0') {
							window.open('/Blocks/ClaimsWidget/GetReport' + '?insuranceNumber=' + self.$widget.find('#InsuranceNumber').val() + '&language=' + self.$widget.find('[data-js="language"] select').val() + '&claimId=' + data.message + '&type=report');
						}
					} else {
						self.$target.html(data.html);
					}
				}, function (data) {
					self.$target.html(data.message);
				});
				
			});
		}
	};

	ClaimsWidget.prototype.init = function () {
		var self = this;
		self.initEventhandlers();
	}

	return ClaimsWidget;
});